import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import DropdownMenu from '../navigation/DropdownMenu';
import { mainNavigation } from '../../config/navigation';

interface HeaderProps {
  className?: string;
}

function Header({ className }: HeaderProps) {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  return (
    <header className={`w-full h-20 flex items-center justify-between px-4 sm:px-6 lg:px-8 ${className || ''}`}>
      <Link to="/" className="flex items-center space-x-3">
        <img
          src="logo512.png"
          alt="eighty-nine AI"
          className="h-10 w-10"
        />
        <span className="text-xl font-bold text-white">
          eighty-nine AI
        </span>
      </Link>
      <nav className="hidden md:flex items-center space-x-8">
        {mainNavigation.map((item) => (
          <DropdownMenu key={item.href} item={item} />
        ))}
        <Link
          to="/waitlist"
          className="bg-blue-600 text-white px-4 py-2 rounded-full hover:bg-blue-700 transition-colors"
        >
          Join Waitlist
        </Link>
      </nav>
      <button 
        className="md:hidden text-white p-2 hover:bg-white/10 rounded-lg transition-colors"
        onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
      >
        {isMobileMenuOpen ? (
          <X className="h-6 w-6" />
        ) : (
          <Menu className="h-6 w-6" />
        )}
      </button>

      <AnimatePresence>
        {isMobileMenuOpen && (
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.2 }}
            className="absolute top-full left-0 right-0 bg-gray-800 shadow-lg md:hidden"
          >
            <div className="px-4 py-6 space-y-4">
              {mainNavigation.map((item) => (
                <div key={item.href} className="space-y-2">
                  <Link
                    to={item.href}
                    className="block text-lg font-medium text-white"
                    onClick={() => setIsMobileMenuOpen(false)}
                  >
                    {item.name}
                  </Link>
                  {item.items && (
                    <div className="ml-4 space-y-2">
                      {item.items.map((subItem) => (
                        <Link
                          key={subItem.href}
                          to={subItem.href}
                          className="block text-gray-300 hover:text-white"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          {subItem.name}
                        </Link>
                      ))}
                    </div>
                  )}
                </div>
              ))}
              <Link
                to="/waitlist"
                className="block w-full text-center bg-blue-600 text-white px-4 py-2 rounded-full hover:bg-blue-700 transition-colors"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Join Waitlist
              </Link>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
}

export default Header;
